
//import 'react-date-range/dist/styles.css'; // main style file
//import 'react-date-range/dist/theme/default.css'; // theme css file





import React, { Component } from "react";
import Select from 'react-select'
import { AutoComplete , Input} from 'antd';
import { DateRangePicker , DateRange} from 'react-date-range';
//import { formatISO, format } from "date-fns";
import moment from 'moment'
import momentLocaliser from 'react-widgets/lib/localizers/moment'
import { sojAndImagesSV } from '../../redux/svractions/svessearchActions';
//import { ar } from 'date-fns/locale';
//const format = require('date-fns/format'); 
import '../../css/SearchBar.css'
import 'antd/dist/antd.css'


const { Search } = Input;


const options = [
    { value: 'chocolate', label: 'Chocolatesweer' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
  ]

const hotels = [
    { value: 'jen', label: 'jen' },
    { value: 'ken', label: 'ken' },
    { value: 'ben', label: 'ben' }
  ]

  const locationOptions = [
    {
        "sojourncode": "201",
        "locationdata": " Hyatt, 153 scottland av, alabany city, ny 12120, us",
        "address_line1": " 253 scottland av",
        "address_line2": "albany "
    },
    {
        "sojourncode": "202",
        "locationdata": " CathyHotel, 153 scottland av, alabany city, ny 12130, us",
        "address_line1": " 410 scottland av",
        "address_line2": "albany "
    }]
  
class FindBar extends Component{
   
/*
    availProcess(data){
        //hotelDest, startDate, endDate
        //clone

        let ob = {
            all: [], // Contains the full data
            HOTEL_DEST: {
                id: "HOTEL_DEST_STATUS", 
                defaultOptions: [], 
                options: [],
                label: "Hptel Location",
                values: [],
                showing: []

            },
            HOTEL_DATE_RANGE: {
               
                    startDate: new Date(),
                    endDate: new Date(),
               
                key: 'selection'
                
            }
        }
        let cfind =  Object.copy({}, this.state.filters)
        cfind.all = []
        

        if(data.hotelDest){
            cfind.HOTEL_DEST = data.hotelDest

        }
        let obRange = {
               
            startDate: new Date(),
            endDate: new Date(),
       
            key: 'selection'
        
        }
        
        if(data.startDate){
            obRange.startDate = data.startDate
        }
        if(data.endDate){
            obRange.endDate = data.endDate
        }

        cfind.HOTEL_DATE_RANGE = obRange

        return cfind



       
    }
    */
    sojAndImagesSVUsingQuery(filter){
        const {startDate, endDate, hotels, esqueryText} = filter
        const {values} = hotels
        //call action
        let start_date_s   = moment(startDate).toISOString() 
        console.log("**formatISO***", start_date_s)


        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moment(endDate).toISOString() 
        console.log("**formatISO***", end_date_s)
        let sojourn_location_s = ''
        let qLocation = 'Terrace'
        if(values && values.value){
            sojourn_location_s = values.value
            if(sojourn_location_s == 'benServer'){
                qLocation = 'Brazil'

            }else if(sojourn_location_s == 'jenServer'){
                qLocation = 'usa'
            }else if(sojourn_location_s == 'kenServer'){
                qLocation = 'WA'
            }
        }
        
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": sojourn_location_s,
                  "operator": "and"
                },
                "from_date": {
                    "query": start_date_s,
                    "operator": "and"
                  },
                  "to_date": {
                    "query": end_date_s,
                    "operator": "and"
                  }

              }
            }
          }
          console.log('sv*** calling action with postDatae')
          console.log(sojPostRq)
          console.log('sv*** calling action with postDatae done' )
          /*localhost:8082/essearch/essojournlist*/
          //esqueryText
          let esRealPostFIlterSearchGoodSVButNodata = {
              "query": {
                  "multi_match": {
                      "fields": [
                          "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                      ],
                      "query": qLocation,
                      "operator": "or",
                      "fuzziness": "AUTO"
                  }
              },
              "post_filter": {
                  "range" : {
                      "STARTDATE": {
                          "gte" : (mo_ss ? mo_ss: "2023-10-24" ),
                          "lt" : (mo_es ? mo_es: "2023-11-27" ), 
                          "time_zone": "+01:00"
                      }
                  }
                }
          }
          let esRealPostFIlterSearch_withDateRangeWorking = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": qLocation,
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : (mo_ss ? mo_ss: "2023-10-24" ),
                        "lt" : (mo_es ? mo_es: "2023-11-27" ), 
                        "time_zone": "+01:00"
                    }
                }
              }
        }
          let esRealPostFIlterSearch = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": qLocation,
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" :"2023-10-24" ,
                        "lt" : "2023-11-27" , 
                        "time_zone": "+01:00"
                    }
                }
              }
        }
          //woring
          //tmep
          esRealPostFIlterSearch["query"]["multi_match"]["query"] = esqueryText
          let sv_esquery_data = {
            my_esqueryText: esqueryText,
            STARTDATE:(mo_ss ? mo_ss: "2023-10-24" ),
            ENDDATE:(mo_es ? mo_es: "2023-11-27" ),
            time_zone: "+01:00"

          }
         
           this.props.sojAndImagesSV(esRealPostFIlterSearch, sv_esquery_data)
        
          /*sv sept12 end */
          //make change in esingest java code with new controller to habdle this
        // this.props.sojAndImagesSV(esRealPostFIlterSearch)
         

    }

    /*sv sept12 start 
    flyAndImagesSVUsingQuery(filter){
        const {startDate, endDate, hotels, esqueryText} = filter
        const {values} = hotels
        //call action
        let start_date_s   = moment(startDate).toISOString() 
        console.log("**formatISO***", start_date_s)


        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moment(endDate).toISOString() 
        console.log("**formatISO***", end_date_s)
        let sojourn_location_s = ''
        let qLocation = 'Terrace'
        if(values && values.value){
            sojourn_location_s = values.value
            if(sojourn_location_s == 'benServer'){
                qLocation = 'Brazil'

            }else if(sojourn_location_s == 'jenServer'){
                qLocation = 'usa'
            }else if(sojourn_location_s == 'kenServer'){
                qLocation = 'WA'
            }
        }
        
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": sojourn_location_s,
                  "operator": "and"
                },
                "from_date": {
                    "query": start_date_s,
                    "operator": "and"
                  },
                  "to_date": {
                    "query": end_date_s,
                    "operator": "and"
                  }

              }
            }
          }
          console.log('sv*** calling action with postDatae')
          console.log(sojPostRq)
          console.log('sv*** calling action with postDatae done' )
         
          //esqueryText
          let esRealPostFIlterSearchGoodSVButNodata = {
              "query": {
                  "multi_match": {
                    "fields": [
                        "ORIGIN_AIRPORT_IATA",
                        "ORIGIN_AIRPORT_CITY",
                        "ORIGIN_AIRPORT_COUNTRY",
                        "AIRLINES_NAME",
                        
                         "FLIGHT_SPACE_KEY"
                       
                    ],
        
                      "query": qLocation,
                      "operator": "or",
                      "fuzziness": "AUTO"
                  }
              },
              "post_filter": {
                  "range" : {
                      "STARTDATE": {
                          "gte" : (mo_ss ? mo_ss: "2023-10-24" ),
                          "lt" : (mo_es ? mo_es: "2023-11-27" ), 
                          "time_zone": "+01:00"
                      }
                  }
                }
          }
          let esRealPostFIlterSearch = {
            "query": {
                "multi_match": {
                    "fields": [
                        "ORIGIN_AIRPORT_IATA",
                "ORIGIN_AIRPORT_CITY",
                "ORIGIN_AIRPORT_COUNTRY",
                "AIRLINES_NAME",
                 
                 "FLIGHT_SPACE_KEY"
                       
                    ],
                    "query": qLocation,
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" :  "2023-10-24" ,
                        "lt" :"2023-11-27" , 
                        "time_zone": "+01:00"
                    }
                }
              }
        }
          //woring
          //tmep
          esRealPostFIlterSearch["query"]["multi_match"]["query"] = esqueryText
        
          // this.props.sojAndImagesSV(esRealPostFIlterSearch)
          this.props.flyAndImagesSV(esRealPostFIlterSearch)
         
          //make change in esingest java code with new controller to habdle this
        // this.props.sojAndImagesSV(esRealPostFIlterSearch)
         

    }
*/
    /*sv sept 12 end */
    loadDDValuesFromServer(){
        console.log('sv--calling acction getLocationDataDefaultFromServer')
        let rqOb = {"notnedded":1}

        let sdServer = "2024-06-22T23:42:55.795+00:00" 

        var str = '2011-04-11T10:20:30Z';
var date = moment(sdServer);
var dateComponent = date.utc().format('YYYY-MM-DD');
var timeComponent = date.utc().format('HH:mm:ss');
console.log(dateComponent);
console.log(timeComponent);

        let s =  moment().toISOString() 
        console.log("**formatISO***", s)
        //const result = formatISO(sdServer)

       // console.log("**formatISO***", result)
/*
        let sd = new Date()
        const formattedDate1 = format(stPattysDay, 'MMMM dd, YYYY'); 
        "June/Mo/2024"
        const formattedDate = format(stPattysDay, 'MM/DD/YYYY') 
        //"06/10/2024" 
        console.log("**formattedDate***", formattedDate)
*/

        this.props.getLocationDataDefaultFromServer(rqOb)
/*
        const {startDate,endDate, hotels, ddData } = this.props
        //use startdate end Date from server and put in the icker
        let  HOTEL_DATE_RANGE= {
                   
            startDate: new Date(),
            endDate: new Date(),
       
        key: 'selection'
        
    }
        this.setState({HOTEL_DATE_RANGE: HOTEL_DATE_RANGE, hotels:hotels, ddData:ddData})
        */

    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        this.loadDDValuesFromServer()
        //console.log(this.props.params)
    }
    componentDidMount(){
       // const f = this.availProcess(this.props.hotelDest,this.props.startDate, this.props.endDate)
       const {hotels,hotelsSelected, ddData, startDate, endDate , dataSourceSV}= this.props.locationData
       let f = {
            all: [], // Contains the full data
            hotels: {
                options:[
                    { value: 'jen', label: 'jen2Server' },
                    { value: 'ken', label: 'ken2Server' },
                    { value: 'ben', label: 'ben2Server' }
                ],
                values: { value: 'ken', label: 'ken2Server' }
            }
        };
        f['hotels']['options'] = hotels
        f['hotels']['values'] = hotelsSelected
        let items = []
        /*
        if(hotels){
           
           
               Array.forEach(hotels, (ob, i)=>{
                   items.push(ob['label'])

               })

        }
        f['hotels']['dataSourceSV'] = items
        */
        let  momIsoStartDate = moment(startDate);
        let  momIsoEndDate = moment(endDate);
////var dateComponent = date.utc().format('YYYY-MM-DD');
//var timeComponent = date.utc().format('HH:mm:ss');
        f['startDate'] = momIsoStartDate
        f['endDate'] = momIsoEndDate
        f['dataSourceSV'] = dataSourceSV
        this.setState({filters:f} )
       // this.setState({filters:f})

    }
    cbFilterac = (inputValue, option)  => {
        /** plain vanilla to return the options that has above inputValue as substring
         */
        console.log('sv$$$$$$$$$***onChangeac***')
       console.log(inputValue)
       console.log(option)
       console.log('sv$$$$$$$$$***onChangeac ebd***')
       let bValid = option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
       return bValid
                              
      //this.setState({ selectedOption: option, inputValue: data });
    };
    onSearchac = searchText => {
        this.setState({
          dataSource: !searchText ? [] : [searchText, searchText.repeat(2), searchText.repeat(3)],
        });
      };

      onSearchtxt = qText => {

        let f = this.state.filters
       
        //let  momIsoStartDate = moment(startDate);
        //let  momIsoEndDate = moment(endDate);
////var dateComponent = date.utc().format('YYYY-MM-DD');
//var timeComponent = date.utc().format('HH:mm:ss');
//nonISO
        f['esqueryText'] = !qText ? [] :  qText
        this.setState({filters:f} )
       
      };
      onChangedsSV = (data, option)  => {
        /** data is the user vals or label that we sotr as inputValue
         * option has storew with key val
         */
        console.log('sv$$$$$$$$$***onChangeac***')
       console.log(data)
       console.log(option)
       
       const rqBody = {inputValueds: data}
       this.props.esautocompleteNow(rqBody)
       console.log('sv$$$$$$$$$***onChangeac ebd***')
     // this.setState({ selectedOptionds: option, inputValueds: data });
    };

    onSelectdsSV = (ddLabel, option) => {
      console.log('sv$$$$$$$$$***onSelectac***')
      console.log(ddLabel)
      console.log(option)
      console.log('sv$$$$$$$$$***onSelectac ebd***')
      this.setState({ selectedOptionds: option, inputValueds: option.label });
    };
      onChangeac = (data, option)  => {
          /** data is the user vals or label that we sotr as inputValue
           * option has storew with key val
           */
          console.log('sv$$$$$$$$$***onChangeac***')
         console.log(data)
         console.log(option)
         console.log('sv$$$$$$$$$***onChangeac ebd***')
        this.setState({ selectedOption: option, inputValue: data });
      };

      onSelectac = (data, option) => {
        console.log('sv$$$$$$$$$***onSelectac***')
        console.log(data)
        console.log(option)
        console.log('sv$$$$$$$$$***onSelectac ebd***')
        this.setState({ selectedOption: option, inputValue: option.label });
      };

    constructor(props) {
        super(props)
        this.cbFilterac = this.cbFilterac.bind(this)
       this.onSelectdsSV = this.onSelectdsSV.bind(this)
       this.onChangedsSV = this.onChangedsSV.bind(this)
        this.onSelectac = this.onSelectac.bind(this)
        this.onChangeac = this.onChangeac.bind(this)
        this.onSearchac = this.onSearchac.bind(this)
        this.onSearchtxt = this.onSearchtxt.bind(this)
        this.sojAndImagesSVUsingQuery = this.sojAndImagesSVUsingQuery.bind(this)
       // this.flyAndImagesSVUsingQuery = this.flyAndImagesSVUsingQuery.bind(this)
        this.loadDDValuesFromServer = this.loadDDValuesFromServer.bind(this)
        this.updateHotelsDD = this.updateHotelsDD.bind(this)
        this.ddChange = this.ddChange.bind(this)
        this.buttonShouldBeDisabled = this.buttonShouldBeDisabled.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
        this.handleInit = this.handleInit.bind(this)
        this.state = { 
            value: '', 
            inputValueds:'',
            //inputValue:'react',
            selectedOptionds: '',
            inputValue:'react',
           
            //inputValue:'react',
            selectedOption: { label: "react", value: "3" },
            dataSource:[
                { label: "hello", value: "1" },
                { label: "codesandbox", value: "2" },
                { label: "react", value: "3" },
                { label: "nodejs", value: "4" },
                { label: "java", value: "5" },
                { label: "antd", value: "6" },
                { label: "dependency", value: "7" },
                { label: "less", value: "8" }
              ],
            /*
            svstate : {
                startDate: new Date(),
                endDate: new Date(),
           
            key: 'selection'
            },  
            */
            ids: ['APP_OPERATIONAL_STATUS', 'DV_U_SERVICE_ASG', 'DV_U_SERVICE_NAME', 'DV_U_SERVICE_OFFERING', 'APPLICATION_NAME'],
            labels: ['Status', 'Service ASG', 'Service Name', 'Service Offering', 'Application'],
            filters: {
                
                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
               // "endDate": "2024-07-22T25:42:55.795+00:00" ,
               startDate : new Date(),
               endDate : new Date(),
               esqueryText: '',
               
               dataSourceSV : ['Burns Bay Road', 'Downing Street', 'Wall Street'],
            
              
                key: 'selection',
                "hotelsSelected":{"value": "kenServer", "label": "kenServer"},
                hotels: {
                    
                    options:[
                        { value: 'jen', label: 'jen1Server' },
                        { value: 'ken', label: 'ken1Server' },
                        { value: 'ben', label: 'ben1Server' }
                    ],
                    values: { value: 'ken', label: 'ken1Server' }
            },
                HOTEL_DEST: {
                    id: "HOTEL_DEST_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Hptel Location",
                    values: [],
                    showing: []

                },
                HOTEL_DATE_RANGE: {
                   
                        startDate: new Date(),
                        endDate: new Date(),
                   
                    key: 'selection'
                    
                },
                APP_OPERATIONAL_STATUS:{
                    id: "APP_OPERATIONAL_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Status",
                    values: [],
                    showing: []
                },
                
                APPLICATION_NAME: {
                    id: "APPLICATION_NAME",
                    defaultOptions: [],
                    options: [],
                    label: "Applications",
                    values: [],
                    showing: []
                }
              
            }
        }
    }
    handleInit(ranges){
        console.log('handleInit');
        console.log(ranges);

    }
    handleSelect(ranges){
        console.log(ranges);
        const { startDate, endDate }= ranges
        let f = this.state.filters
       
         //let  momIsoStartDate = moment(startDate);
         //let  momIsoEndDate = moment(endDate);
 ////var dateComponent = date.utc().format('YYYY-MM-DD');
 //var timeComponent = date.utc().format('HH:mm:ss');
 //nonISO
         f['startDate'] = startDate
         f['endDate'] = endDate
         this.setState({filters:f} )


        
        // {
        //   selection: {
        //     startDate: [native Date Object],
        //     endDate: [native Date Object],
        //   }
        // }
      }

    buttonShouldBeDisabled(){
        if( this.state.filters.APPLICATION_NAME.values.length > 0)
            return false;
       
        return true
    }
    updateHotelsDD(statekey,obSelect){
        console.log('sv**** user selected hotel start')
        console.log(obSelect)
        console.log('sv**** user selected hotel ..')
        let f = this.state.filters

       
        f['hotels']['values'] = obSelect
        this.setState({filters:f} )

    }
    ddChange(rangesGot){
        
        console.log(rangesGot)
    }
    render(){
        const me = this
        console.log('sv*** this.props')

        console.log(this.props)
        const options =[
            { label: "hello", value: "1" },
            { label: "codesandbox", value: "2" },
            { label: "react", value: "3" },
            { label: "nodejs", value: "4" },
            { label: "java", value: "5" },
            { label: "antd", value: "6" },
            { label: "dependency", value: "7" },
            { label: "less", value: "8" }
          ]
        const { dataSource, inputValue } = this.state
        
        const {locationData} = this.props
        //const dataSourceSV = this.state.filters['dataSourceSV']

       

        const {ddData, dataSourceSV} = locationData
        
        const svselectionRange = {
            startDate: new Date(),
            endDate: new Date(),
            key:'selection'
        }
        const bdisableDaysBeforeToday = true
       // const dataSourceSV = ['Burns Bay Road', 'Downing Street', 'Wall Street'];
       

        return (
            <div>
                <div className="searchBar">
               
        {/*  
     <div>
        
        <br />
        <AutoComplete
        value={inputValue}
        options = {options}

       
        
        autoFocus={true}
        filterOption = {(inputValue, option)  => {
           
            console.log('s++++$$$$$$$***onChangeac***')
           console.log(inputValue)
           console.log(option)
           console.log('s+++$$$$$$$***onChangeac ebd***')
           let bValid = option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
           return bValid
                                  
          //this.setState({ selectedOption: option, inputValue: data });
        }}

        filterOption= {this.cbFilterac}
       

        style={{ width: 200 }}
        onSelect={this.onSelectac}
        onSearch={this.onSearchac}
        onChange={this.onChangeac}
        placeholder="control mode"
        />

<AutoComplete
      style={{ width: 200 }}
      dataSource={dataSourceSV}
      placeholder="try to type `b`"
      filterOption={(inputValue, option) =>
        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
      }
    />
</div>
    */}

                    <div className="container-fluid">
                      
                        <div className="row">
                        <div className="c-container-sbar">

                        <div className="c-box-sbar">
                            <span className="c-span">
                            <div>
        
                                <br />
        
                                <Search
                                    placeholder="input search text"
                                    onSearch={this.onSearchtxt}
                                    style={{ width: 200 }}
                                    />
                            </div>
                            
                            </span>
                        </div>

                        <div className="c-box-sbar">
                            <span className="c-span">
                            <div>
        
                                <br />
        
                                <AutoComplete
                                    style={{ width: 200 }}
                                    onChange={this.onChangedsSV}
                                    onSelect={this.onSelectdsSV}
                                    dataSource={dataSourceSV}
                                    placeholder="try to type `b`"
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    />
                            </div>
                            
                            </span>
                        </div>

                            {/*

                            <div className="svr-serachbar-box-row1">
                            className='dropdown_width'
                            <Select options={options} />
                             */}
                             <div className="c-box-sbar">
                              <span className="c-span">
                            <Select options={hotels} 
                            onChange = { (args) => this.updateHotelsDD('hotels', args)}
                            classNamePrefix = {"dropdown_li"}
                            className = {"dropdown_search"}
                            options = {this.state.filters['hotels'].options}
                           value = {this.state.filters['hotels'].values}
                           
                            />
                            </span>
                            </div>
                           
                            <span className="c-span">
                                <DateRange disableDaysBeforeToday={bdisableDaysBeforeToday} onInit={this.handleInit}  onChange={this.handleSelect} />
                           </span>
                           <div className="c-box-sbar">
                                <span className="c-span">
                            
                                    <button type="submit" className="btn btn-success" onClick={()=>this.sojAndImagesSVUsingQuery(this.state.filters)}>
                                        Searchsvg
                                    </button>  

                                   
                            
                                </span>
                            </div>
                     </div>
                                    
                            
                            
                        </div>
                    </div>
                </div>
            </div>
           
        )
    }




}

export default FindBar